import { createBuildData } from 'web/data/core-data'
import { BuildData } from 'web/data/models'
import { applyResolvers, CooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { assertDefined } from 'web/utils/utils'
import { GENERATED_MAIN } from './generated-main'
import { GENERIC_RESOLVERS, SPELL_RESOLVERS } from './resolvers'

export const Build_1100_1: BuildData = createBuildData({

    buildVersion: GENERATED_MAIN.patchInfo.buildVersion,
    changelog: GENERATED_MAIN.changelog,

    modifiers: GENERATED_MAIN.modifiersById,
    specs: GENERATED_MAIN.specsById,
    spells: GENERATED_MAIN.spellsById,
    talents: GENERATED_MAIN.talentsById,

    __CooldownResolver: (spellId: string): CooldownResolver => {
        let spell = GENERATED_MAIN.spellsById[spellId]
        assertDefined(spell)

        const maybeResolver = SPELL_RESOLVERS[spell.id]

        return (spell, player) => {

            // Resolve the initial cooldown
            const initialCooldown = (maybeResolver != null)
                ? maybeResolver(spell, player)
                : spell.cooldown

            return applyResolvers({
                spell,
                player,
                cooldown: initialCooldown,
                resolvers: GENERIC_RESOLVERS
            })

        }
    }
})
